import { render, staticRenderFns } from "./KpiSalesText.vue?vue&type=template&id=3001d0a2&"
import script from "./KpiSalesText.vue?vue&type=script&lang=js&"
export * from "./KpiSalesText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports